import { createContext, useContext } from "react";
import { useAdminSettings } from "./useAdmin";

const CoreTimezoneContext = createContext<string | undefined>(undefined);

function useCoreTimezoneValue(): string {
  const { data: settings } = useAdminSettings();
  const general = settings?.["admin.general"] as { timezone?: string } | undefined;
  return general?.timezone || "UTC";
}

export function CoreTimezoneProvider({ children }: { children: React.ReactNode }): React.ReactElement {
  const tz = useCoreTimezoneValue();
  return (
    <CoreTimezoneContext.Provider value={tz}>
      {children}
    </CoreTimezoneContext.Provider>
  );
}

export function useCoreTimezone(): string {
  return useContext(CoreTimezoneContext) ?? "UTC";
}

export function useTimezoneOptions(): string[] {
  // Use Intl.supportedValuesOf if available (modern browsers)
  if (typeof Intl !== "undefined" && typeof (Intl as unknown as { supportedValuesOf?: (key: string) => string[] }).supportedValuesOf === "function") {
    try {
      const zones = (Intl as unknown as { supportedValuesOf: (key: string) => string[] }).supportedValuesOf("timeZone");
      if (zones.length > 0) return zones;
    } catch {
      // fall through to hardcoded list
    }
  }
  // Fallback: common timezones
  return [
    "UTC",
    "America/Sao_Paulo",
    "America/Manaus",
    "America/Fortaleza",
    "America/Recife",
    "America/Belem",
    "America/Bahia",
    "America/Campo_Grande",
    "America/Cuiaba",
    "America/Porto_Velho",
    "America/Boa_Vista",
    "America/Noronha",
    "Europe/Lisbon",
    "America/New_York",
    "Europe/London",
    "Europe/Madrid",
    "America/Argentina/Buenos_Aires",
    "America/Santiago",
    "America/Lima",
    "America/Bogota",
    "America/Mexico_City",
    "Asia/Tokyo",
  ];
}
